import type { PersistedMonthlyExportSettings } from "./types";

/**
 * Force the one combination the monthly document must never express.
 *
 * Gaps are computed per shift-time window, so flat (`none`) mode has no window to attribute one to.
 * `MonthlyExportTab.handleSettingChange` clears the flag on the transition and `MonthlyExportSettings`
 * forces the checkbox off, so the panel cannot produce the pair — but the backend's
 * `StaffingMonthlyExportSettings` has no cross-field validator, so a document written by anything else
 * can still arrive holding it. Left raw, that value reaches the preview request and is written straight
 * back the moment separation returns to `sections`, showing a ticked box the user never ticked.
 *
 * Returns the SAME object when there is nothing to fix: the tab compares `columnWidths` by identity to
 * decide whether the cached workbook is a width behind, so a fresh copy per render would read as a
 * permanently pending drag.
 */
export const normalizeMonthlySettings = (settings: PersistedMonthlyExportSettings): PersistedMonthlyExportSettings =>
	settings.shiftTimeSeparation === "none" && settings.printGaps ? { ...settings, printGaps: false } : settings;
